import React, { useState, useEffect } from 'react';
import Navbar from './components/navbar';
import Hero from './components/pages/Hero';
import About from './components/pages/About';
import Experience from './components/pages/Experience';
import Skills from './components/pages/Skills';
import Projects from './components/pages/Projects';
import Certifications from './components/pages/Certifications';
import Achievements from './components/pages/Achievements';
import Contact from './components/pages/Contact';
import Footer from './components/footer';
import LoadingScreen from './components/pages/loadingscreen';
import ParticleBackground from './components/pages/ParticleBackground';
// import MouseSpotlight from './components/pages/MouseSpotlight';


function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen bg-dark text-light relative">
      <ParticleBackground />
      {/* <MouseSpotlight/> */}
      <div className="relative z-10">
        <Navbar />
        <main>
          <Hero />
          <About />
          <Experience />
          <Skills />
          <Projects />
          <Certifications />
          <Achievements />
          <Contact />
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default App;